module.exports = __webpack_public_path__ + "static/banner-746f3b8b519d2f308af3e428dbc81a90.png";